/* ============================================================
   INDSO — contact.js
   Lightweight submit loader for the contact form. Relies on
   native HTML validation (required / type=email / type=tel) —
   the loader only appears once the browser reports the form as
   valid, so invalid submits never get stuck spinning.
   ============================================================ */
(function () {
  'use strict';

  const ready = (fn) =>
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);

  ready(() => {
    const form = document.getElementById('ContactForm');
    if (!form) return;
    const btn = form.querySelector('[data-contact-submit]');
    if (!btn) return;

    form.addEventListener('submit', () => {
      // Native validation runs first. If invalid, the browser blocks
      // submission and fires no loader — restore nothing needed.
      if (!form.checkValidity()) return;

      if (btn.classList.contains('is-loading')) return; // guard repeat clicks

      // Lock width to prevent layout shift, then swap text for a spinner.
      const w = btn.getBoundingClientRect().width;
      btn.style.minWidth = w + 'px';
      btn.dataset.text = btn.innerHTML;
      btn.classList.add('is-loading');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.innerHTML = '<span class="btn-spinner" aria-hidden="true"></span>';
      // The form does a normal POST to Shopify and the page reloads,
      // so the button state resets naturally on the next render.
    });

    // Safety net: if the page is restored from bfcache (back button),
    // make sure the button is interactive again.
    window.addEventListener('pageshow', () => {
      if (btn.classList.contains('is-loading')) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.style.minWidth = '';
        if (btn.dataset.text) btn.innerHTML = btn.dataset.text;
      }
    });
  });
})();
